import { EnumUserType, ENUMUSERTYPE_OPTION } from "../../../generated/enums";
import { BadgeFilter } from "../../common/BadgeFilter";
import { UserTypeBadge } from "./UserTypeBadge";

type UserTypeFilterProps = {
  value: EnumUserType | "";
  onChange: (value: EnumUserType | "") => void;
};

export const UserTypeFilter = ({ value, onChange }: UserTypeFilterProps) => {
  return (
    <BadgeFilter
      value={value}
      onChange={onChange}
      options={ENUMUSERTYPE_OPTION}
      renderBadge={(type) => <UserTypeBadge type={type} />}
    />
  );
};
